<section class="users-edit">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- Nav-tabs -->
              <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs justify-content-left">
                <li [ngbNavItem]="1">
                  <a ngbNavLink class="nav-link d-flex align-items-center">
                    <i class="ft-user mr-1"></i>
                    <span class="d-none d-sm-block">Account</span>
                  </a>
                  <ng-template ngbNavContent>
                    <!-- Account content starts -->
                    <div class="mt-2" id="account">
                      <!-- Media object starts -->
                      <div class="media">
                        <img *ngIf="imgUrl" [src]="imgUrl" alt="user edit avatar"
                          class="users-avatar-shadow avatar mr-3 rounded-circle" height="64" width="64">
                          <img  *ngIf="!imgUrl" [src]="imageUrl + courseData?.image" alt="user edit avatar"
                          class="users-avatar-shadow avatar mr-3 rounded-circle" height="64" width="64">
                        <!-- <div class="media-body">
                          <h4>{{courseData?.courseName}}</h4>
                           <div class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
                            <label class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset">Change 
                              <input type="file" #fileInput class="form-control" (change)="onSelectFile($event)" hidden/>
                              </label>
                            <button class="btn btn-sm bg-light-secondary ml-sm-2" (click)="resetImage()">Reset</button>
                          </div>
                        </div> -->
                      </div>
                      <!-- Media object ends -->
  
                      <!-- Account form starts -->
                      <form >
                        <div class="row">
                          <div class="col-md-6">
                           
                            <fieldset class="form-group">
                              <label for="fees">Course Fee</label>
                              <input type="text" class="form-control"   [(ngModel)]="notificationData.title" [ngModelOptions]="{standalone: true}" id="fees"  placeholder="Enter Course Fee" #fees>
                            </fieldset>    
                            <fieldset class="form-group">
                              <label for="durations">Course Duration</label>
                              <input type="text" class="form-control"   [(ngModel)]="notificationData.description" [ngModelOptions]="{standalone: true}" id="durations"  placeholder="Enter Course Durations" #durations>
                            </fieldset>   
                              
                                               
                        </div>                        
                          <div class="col-md-6">
                            
                            <fieldset class="form-group">
                              <label for="durations">Pre Knowledge</label>
                              <input type="text" class="form-control"   [(ngModel)]="notificationData.joiningLink" [ngModelOptions]="{standalone: true}" id="durations"  placeholder="Enter Course Durations" #preKnowledge>
                            </fieldset> 
                            <fieldset class="form-group">
                              <label for="durations">Announcements</label>
                              <input type="text" class="form-control"   [(ngModel)]="notificationData.isRead" [ngModelOptions]="{standalone: true}" id="durations"  placeholder="Enter Course Durations" #announcements>
                            </fieldset> 
                            <!-- <fieldset class="form-group">
                              <label for="tag">Select Tag</label>
                              <select id="tag" class="form-control"
                                [(ngModel)]="selectedValue && courseData.tagsId[0]._id" [ngModelOptions]="{standalone: true}"
                                (change)="getTagsId($event)" #Tags>
                                <option value="" disabled>Select Tags</option>
                                <option *ngFor="let tag of tags" [value]="tag._id">{{tag.tagName}}</option>
                              </select>
                            </fieldset> -->
                            <!-- <fieldset class="form-group">
                              <label for="categary">Course Banner</label>                            
                              <img *ngIf="!imgUrl" [src]="imageUrl+courseData.image" alt="" width="100px" height="100px">
                              <img *ngIf="imgUrl" [src]="imgUrl" alt="" width="100px" height="100px">
                            </fieldset>
                            <fieldset class="form-group">
                              <label class="btn btn-sm btn-primary mb-1 mb-sm-0 text-transform-unset">Change 
                              <input type="file" class="form-control"  (change)="onSelectFile($event)" id="actual-btn" hidden/>
                              </label>
                            </fieldset>   -->

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                              <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" 
                               (click)="submit()">Submit</button>
                              <button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
                            </div>
                         </div>
                        </div>
                       
                      </form>
                      <!-- Account form ends -->
                    </div>
                    <!-- Account content ends -->
                  </ng-template>
                </li>
            
              </ul>
              <div class="tab-content">
                <div [ngbNavOutlet]="nav"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  

